module.exports = __webpack_public_path__ + "media/images/responsive/costumes/search_button-24affef924ecd710f85d25098a2854a5.png";